export const BASE_URL = "https://lk.xbadm.ru";
// export const BASE_URL = "http://127.0.0.1:8000";
